<template>
  <div>
    <div class="row position-relative mt-3 mb-3">
      <div class="col w-100 text-center">
        <h3>POLAND ORDERS</h3>
      </div>
    </div>

    <div class="bg-dark p-3 rounded order-toolbar">
      <div class="order-field order-field-wide">
        <label for="sku">SKU</label>
        <input v-model="newArticle.sku" class="w-100 input-group-text" type="text" id="sku" required>
      </div>
      <div class="order-field order-field-wide">
        <label for="meta">ORDER FOR</label>
        <input v-model="newArticle.meta" class="w-100 input-group-text" type="text" id="meta" required>
      </div>
      <div class="order-field order-field-narrow">
        <label for="qtt">+QTT</label>
        <input v-model.number="newArticle.qtt" class="w-100 input-group-text" type="number" inputmode="decimal" id="qtt" required>
      </div>
      <div class="order-field">
        <button @click="addArticle" class="w-100 btn btn-success">ADD TO ORDER</button>
      </div>
      <div class="order-field">
        <button @click="importWeb" class="w-100 btn btn-warning">IMPORT WEB</button>
      </div>
      <div class="order-field">
        <button :disabled="!filteredList.length" @click="downloadFile" class="w-100 btn btn-danger">CLOSE ORDER</button>
      </div>
    </div>

    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div class="row">
      <div v-if="activeForOrder.length" class="w-100 mt-5 table-responsive">
        <table class="table">
          <thead>
          <tr class="align-middle">
            <th scope="col">Sold</th>
            <th scope="col">SKU</th>
            <th scope="col">Article num</th>
            <th scope="col">QTT</th>
            <th scope="col">Stock</th>
            <th scope="col">PLN</th>
            <th scope="col">Ordered for</th>
            <th scope="col" class="text-center">Remove</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row) of filteredList" v-bind:key="row._id"  :style="`border-bottom: 6px solid ${getRowStyle(row.product)};`">
            <th v-b-tooltip.hover.left="'Sold in last 3 months'" class="align-middle" scope="row">{{psLookup[row.sku] || 0 }}</th>
            <th v-b-tooltip.hover.left="`Ordered by: ${getUserFromRow(row)}`" class="align-middle pointer" scope="row">
              <a @click="openArticle(row.sku)">{{row.sku}}</a>
            </th>
            <th @click="showImage(row.product)" class="align-middle pointer" scope="row">{{row.num}}</th>
            <td class="align-middle">{{row.count}}</td>
            <td class="align-middle">{{row.product.localCount || 0}}</td>
            <td class="align-middle">{{row.price.toFixed(2).toLocaleString('en') || 0}}</td>
            <td class="align-middle">{{row.metaData || 'WORKSHOP'}} {{row.urgent ? '🔥' : ''}}</td>
            <td class="align-middle text-center">
              <button @click="removeArticle(row._id)" class="btn btn-light w-75">
                <b-icon-trash></b-icon-trash>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="w-100 mt-5 text-center">
        <h3 v-if="!loading">Nothing to order for now 😴</h3>
      </div>
    </div>

    <div v-if="activeForOrder.length" class="row">
      <div class="overflow-hidden ml-auto">
        <table class="table font-weight-bolder float-right">
          <tr>
            <td>TOTAL ORDER VALUE:</td>
            <td class="text-right">{{totalPrice.toFixed(2).toLocaleString('en')}} PLN</td>
          </tr>
          <tr>
            <td>TOTAL PIECES:</td>
            <td class="text-right">{{totalCount}}</td>
          </tr>
        </table>
      </div>
    </div>
    <b-modal ref="image-modal" id="image-modal" hide-footer title="Product image">
      <div class="d-block text-center">
        <b-img :src="articleDetails.image" fluid alt="No image"></b-img>
      </div>
      <div class="border bg-light rounded text-dark flex-column">
        <p class="pt-3 pl-3"><strong>OEM codes: </strong>{{articleDetails.oems || 'No OEM codes for this product'}}</p>
      </div>
      <div class="mt-1 border bg-light rounded text-dark text-center flex-column">
        <p class="pt-3 pl-3"><a :href="articleDetails.link" target="_blank" rel="noopener noreferrer">View article on bdbildeler.no</a></p>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="$bvModal.hide('image-modal')">Close</b-button>
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '../fixed';

const BASE_API_URL = fixed.API_URL;
export default {
  data: () => ({
    loading: false,
    newArticle: {
      sku: '',
      qtt: 0,
      meta: 'WORKSHOP',
    },
    activeForOrder: [],
    psLookup: {},
    totalCount: 0,
    totalPrice: 0,
    articleDetails: {
      image: null,
      link: null,
      oems: [],
    },
    moment,
  }),
  computed: {
    filteredList() {
      return this.activeForOrder.filter((row) => row.sku.match(this.newArticle.sku));
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getActive();
    } catch (error) {
      if (error.response && error.response.status === 403) {
        this.$toast.warning('you\'re not authorised for that action ✋🏻');
      } else {
        alert(error); // eslint-disable-line
      }
    }
    this.loading = false;
  },
  methods: {
    async importWeb() {
      this.loading = true;
      try {
        await axios.get(`${BASE_API_URL}/import-web`, { withCredentials: true });
        await this.getActive();
        this.$toast.success('Web-shop articles import done');
      } catch (error) {
        if (error?.response?.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else if (error?.response?.status === 400 || error?.response?.status === 429) {
          this.$toast.warning(error?.response?.data);
        } else {
          alert(error?.response?.data || error); // eslint-disable-line
          // some orders may still have been imported
          await this.getActive();
        }
      }
      this.loading = false;
    },
    async addArticle() {
      if (this.newArticle.qtt < 1 || !this.newArticle.sku || !this.newArticle.meta) return;

      this.loading = true;
      try {
        await axios.post(`${BASE_API_URL}/admin/poland-order`, this.newArticle, { withCredentials: true });
        this.resetNewArticle();
        await this.getActive();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    async removeArticle(id) {
      // Make sure you really want to remove the article
      if (!confirm('Are you sure you want to remove this article from the order?')) return; // eslint-disable-line
      // if there is no article ID we stop
      if (!id) return;

      this.loading = true;
      try {
        await axios.delete(`${BASE_API_URL}/admin/poland-order/${id}`, { withCredentials: true });

        await this.getActive();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    async getActive() {
      this.loading = true;

      this.totalCount = 0;
      this.totalPrice = 0;
      this.activeForOrder = [];

      const lookFor = [];

      try {
        const { data } = await axios.get(`${BASE_API_URL}/poland-order`, { withCredentials: true });
        if (!data || !data.length) {
          this.activeForOrder = [];
        } else {
          this.activeForOrder = data.sort((a, b) => {
            if (a.metaData.toLowerCase() < b.metaData.toLowerCase()) return -1;
            if (a.metaData.toLowerCase() > b.metaData.toLowerCase()) return 1;
            return 0;
          });

          this.activeForOrder.forEach((row) => {
            this.totalCount += row.count;
            this.totalPrice += (row.price * row.count);
            lookFor.push(row.sku);
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;

      await this.getPreviouslySold(lookFor);
    },
    async getPreviouslySold(articles) {
      if (!articles || !articles.length) return;

      try {
        const { data } = await axios.get(`${BASE_API_URL}/previously-sold`, {
          withCredentials: true,
          params: {
            a: articles.join(','),
          },
        });
        if (!data || !data.length) {
          this.$toast('None of the articles sold in last 3 months');
          return;
        }

        this.psLookup = data.reduce((obj, item) => {
          obj[item._id] = (obj[item._id] || 0) + item.sold; // eslint-disable-line
          return obj;
        }, {});
      } catch (error) {
        alert(error); // eslint-disable-line
      }
    },
    async downloadFile() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_API_URL}/admin/process-order`, { responseType: 'blob', withCredentials: true });
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        const fileName = `${moment().format('DD.MM.yyyy-HH.mm')}.csv`;

        link.href = url;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();
        link.remove();

        this.activeForOrder = [];
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for that action ✋🏻');
        } else {
          alert(error); // eslint-disable-line
        }
      }
      this.loading = false;
    },
    showImage(article) {
      // Product image
      this.articleDetails.image = article.images?.image ? article.images.image[0].url : null;
      // Link to bd web-shop
      this.articleDetails.link = article?.URL || null;

      // Product OEM numbers
      this.articleDetails.oems = []; // just so we remove if we have some from before
      const codes = article?.productCodes?.productCode;
      if (codes.length) {
        const OEMcodes = [];
        codes.forEach((c) => {
          if (c.abbreviation === 'OEM') OEMcodes.push(c.code);
        });

        if (OEMcodes.length) this.articleDetails.oems = OEMcodes.join(', ');
      }

      // If we don't have either of the two we don't open the modal
      if (!this.articleDetails.image && !this.articleDetails.oems.length) return;

      this.$refs['image-modal'].show();
    },
    getRowStyle(article) {
      if (!article?.localCount) return '';

      const diff = moment().diff(moment(article.updatedAt), 'months', true);
      switch (true) {
        case diff <= 1:
          return 'green';
        case diff > 1 && diff <= 3:
          return 'yellow';
        case diff > 3 && diff <= 6:
          return 'orange';
        case diff > 6 && diff <= 12:
          return 'red';
        default:
          return 'purple';
      }
    },
    getUserFromRow(row) {
      if (row.fromWeb) return 'WEBSITE';
      return row?.user ? row.user.username.toUpperCase() : 'AUTOMATION';
    },
    resetNewArticle() {
      this.newArticle.sku = '';
      this.newArticle.qtt = 0;
    },
    openArticle(sku) {
      this.$router.push({ name: 'local-stock', params: { codename: sku } });
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

/* Responsive order toolbar: fields wrap into rows on narrow screens */
.order-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

.order-toolbar .order-field {
  flex: 1 1 150px;
  min-width: 130px;
}

.order-toolbar .order-field-wide {
  flex: 2 1 200px;
}

.order-toolbar .order-field-narrow {
  flex: 0 1 90px;
  min-width: 80px;
}
</style>
